import { CESimpleAttributeAttributesBase } from './ce-simple-attribute-attributes-base'


export class CESimpleAttributeAttributes extends CESimpleAttributeAttributesBase {

}